import { useSelector } from "react-redux";
import { selectDefaultSearchLocation } from "../../../ducks/auth/selectors";

const useDefaultSearchLocation = () => {
  return useSelector(selectDefaultSearchLocation);
}

export default useDefaultSearchLocation;